import React from 'react'
import {Link} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import lock_icon from './lock.svg';


class Mollie extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    if(this.props.mollie_url === null) {
      return (
        <div id="mollie-wrap">
          <form onSubmit={this.handleSubmit}>
            <div className="card-layout">
              <div style={{width:"70%", alignSelf:"flex-start"}}><p>{this.props.title}</p></div>
              <div style={{width:"30%"}}><p style={{color:"#8bc34a", textAlign:"right"}}>€ 19</p>
              <small style={{opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>(incl. 21% VAT)</small></div>
            </div>
            <div className="note">Your One-Time Payment will instantly give access to all Premium features of {this.props.app_name}, now and forever. All purchases are non-refundable.<br/><br/>By clicking <b>BUY NOW</b>, I agree to the Polymedia <Link to="/terms" target="_blank">Terms</Link> and understand that my purchase is final.</div>
            <div><input type="submit" value="BUY NOW" disabled={this.props.mollie_url_is_fetching} className="btn btn-full" /></div>
            <div className="secure"><img src={lock_icon} alt="Secure Checkout" />Secure Checkout</div>
          </form>
        </div>
      );
    } else if(this.props.mollie_url !== null) {
      return (
        <div id="mollie-wrap">
          <div className="card-layout">
            <div style={{width:"70%", alignSelf:"flex-start"}}><p>{this.props.title}</p></div>
            <div style={{width:"30%"}}><p style={{color:"#8bc34a", textAlign:"right"}}>€ 19</p>
            <small style={{opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>(incl. 21% VAT)</small></div>
          </div>
          <div className="note">Polymedia uses Mollie to handle the payment process. Go to the Payment Environment by clicking "continue". After the payment has been accepted, please re-open the Configuration Panel on Twitch and confirm that the Premium Tab now says "Premium Enabled" instead of "Go Premium".</div>
          <div style={{textAlign:"right"}}><a href={this.props.mollie_url} rel="noopener noreferrer" onClick={() => this.props.clearStateBlock("mollie_url")} className="btn">continue</a></div>
          <div className="secure"><img src={lock_icon} alt="Secure Checkout" />Secure Checkout</div>
        </div>
      );
    } else {
      return null;
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.props.mollie_url_is_fetching === false || this.props.mollie_url_is_fetching === null) {
      this.props.fetchDataIfReady(config.api_token, "mollie_url", "GET", config.api_url+"/ZhjMHbqnX7y6sKGu?app="+this.props.app+"&ext="+this.props.ext, undefined, null, true);
    }
  }

}


function mapStateToProps(state) {
  let mollie_url_is_fetching = null, mollie_url = null;
  if(state.apiData["mollie_url"] !== undefined && state.apiData["mollie_url"].isFetching !== undefined) {
    mollie_url_is_fetching = state.apiData["mollie_url"].isFetching;
    if(state.apiData["mollie_url"].data !== undefined && state.apiData["mollie_url"].data.url !== undefined) {
      mollie_url = state.apiData["mollie_url"].data.url;
    }
  }
  return {
    mollie_url_is_fetching: mollie_url_is_fetching,
    mollie_url: mollie_url,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Mollie)



// WEBPACK FOOTER //
// ./src/containers/Mollie.js